import styled from "styled-components";

export const EditorContainer = styled.div<{ $width?: string }>`
  background-color: var(--ons-color-white);
  ${(properties) =>
    properties.$width !== undefined ? `max-width: ${properties.$width}ch;` : ""}
`;

